module.exports = __webpack_public_path__ + "img/jia_nav.4d1b380f.png";